import {
  Input,
  Modal,
  Form,
  Select,
  Button,
  Space,
  message,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle
} from "react";
import {
  TeamOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import '../index.scss'

const GroupModal = forwardRef(({submitInitFn}, ref) => {
  const [form] = Form.useForm();
  const [modalFlag, setModalFlag] = useState(false);
  const [isEditFlag, setIsEditFlag] = useState(true);
  const [record, setRecord] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  useImperativeHandle(ref, () => ({
     openModal: async({isEidt = false, record = {}} = {}) => {
      setIsEditFlag(isEidt)
      setRecord(record)
      setModalFlag(true)
    }
  }));

  const afterOpenChangeFn = (flag) => {
    if(flag){
      console.log(record);
      if(isEditFlag){
        form.setFieldsValue({
          ...record
        })
      }
    }else{
      form.resetFields()
      setBtnLoading(false);
    }
  }

  const submitFn = async() => {
    setBtnLoading(true)
    const params = {
      ... form.getFieldsValue(),
      reportGroupId: isEditFlag ? record?.reportGroupId : undefined,
      reportNameId: 48,
    }
    const response = await http.post(isEditFlag ? api.operatingStatementAnalysisUpdateGroup : api.operatingStatementAnalysisCreateGroup, params);
    if(response.code === '1'){
      message.success(`Successfully ${isEditFlag ? 'Update' : 'Create'} Group.`);
      setModalFlag(false)
      submitInitFn()
    }else{
      message.warning(`Failed ${isEditFlag ? 'Update' : 'Create'} Group.`);
    }
    setBtnLoading(false)
  }
  
  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
          <TeamOutlined style={{ marginRight: "8px" }} />
            {isEditFlag ? 'EDIT REPORT GROUP' : 'Create Group'}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      afterOpenChange={afterOpenChangeFn}
      width="50%"
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form 
        form={form} 
        layout="vertical"
        initialValues={{
          displayAs: -1,
        }}
      >
        <Form.Item
          name="nameGroup"
          label="Group Name"
          rules={[{ required: true, message: 'Group Name is required!' }]}
        >
          <Input
            placeholder="Please input Group Name"
          />
        </Form.Item>

        <Form.Item
          name="displayAs"
          label="Display"
          rules={[{ required: true, message: 'Display is required!' }]}
        >
          <Select
            placeholder="Select Display"
            options={[
              {label: 'Positive', value: -1},
              {label: 'Negative', value: 1},
            ]}
          />
        </Form.Item>

        {isEditFlag && <Form.Item
          name="usid"
          label="Usid"
          rules={[{ required: true, message: 'Usid is required!' }]}
        >
          <Input
            disabled
            placeholder="Please input Usid"
          />
        </Form.Item> || null}
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading}>
            Submit
          </Button>
        </Space>
      </div>
    </Modal>
  );
});
export default GroupModal;
